import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  autocompleteMenu: css`
    width: 480px;
  `,
  typeToSearchForAnAddress: ({ theme }) => css`
    color: ${theme.colors.neutral.variant[60]};
    background: white;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
